import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import { setLastRouter, getStorage,goBack,setStorage} from '../libs/utils'
import { Dialog } from 'vant'

Vue.use(Router)
const router = new Router({
    routes,
    mode: 'history'
})
const LOGIN_PAGE_NAME = 'login';
const homeName = 'index';

var checkLogin  =   (to,token,next)=>{
    if (to.meta.noLogin!==true ) {
        if (!token && to.name !== LOGIN_PAGE_NAME) {
            // 未登录且要跳转的页面不是登录页 记录跳转地址后 登录成功后回调
            // Dialog.confirm({
            //     title: '提示',
            //     message: '当前页面需要登录后才可访问,前往登录页面?',
            //     confirmButtonColor:"#F15B24"
            // }).then(() => {
            //     setLastRouter(to)
            //     next({
            //         name: LOGIN_PAGE_NAME, // 跳转到登录页
            //         query: to.query
            //     })
            // }).catch(() => {
            //     store.commit('handleSpinShow', false)
            //     goBack()
            //
            // });
            setLastRouter(to)
            next({
                name: LOGIN_PAGE_NAME, // 跳转到登录页
                query: to.query
            })
        } else {
            next();
        }

    } else {
        if (!token && to.name === LOGIN_PAGE_NAME) {
            // setLastRouter(to)
            // 未登陆且要跳转的页面是登录页
            next() // 跳转
        } else if (token && to.name === LOGIN_PAGE_NAME) {
            // 已登录且要跳转的页面是登录页
            next({
                name: homeName // 跳转到homeName页
            })
        } else {
            next();
        }

    }
}
router.beforeEach((to, from, next) => {
    if(to.meta.showloading) store.commit('handleSpinShow', true)
    //appInfo 原始链接
    if (to.query && to.query.ei) store.dispatch('handleAppInfo', to.query.ei);
    let appInfo =   getStorage('appInfo');
    const token = getStorage('userInfo')
    if(!appInfo) {
       store.dispatch('getLaunchInfo').then(()=>{
        checkLogin(to,token,next);
       })
    }else{
        checkLogin(to,token,next);
    }




})

router.afterEach((to) => {

    //ios wechat sdk
    if (window.__wxjs_is_wkwebview) {  // IOS
        if (window.entryUrl == '' || window.entryUrl == undefined) {
            var url = `${window.location.origin}${to.fullPath}`
            window.entryUrl = url    // 将后面的参数去除
        }
    }

    if (to.meta.title) {
        document.title = to.meta.title;
    }
    window.scrollTo(0, 0)
    setTimeout(() => {
        store.commit('handleSpinShow', false)
    }, 100)
})

export default router
